import EntityManager from '@/pages/admin/components/EntityManager';
import { ministryFields, ministryColumns } from '@/pages/admin/entityConfigs';

export default function MinistriesPage() {
  return (
    <EntityManager
      table="ministries"
      fields={ministryFields}
      columns={ministryColumns}
      orderBy="name"
      ascending
      searchKeys={['name', 'leader']}
      addLabel="Add Ministry"
    />
  );
}